export const getCache = keys => {
	const result = [keys].flat()
		.map(k => [k, localStorage.getItem(k)])
		.filter(([key, val]) => val)

	return result.length === 0
		? undefined
		: result.length === 1
		? result[0][1]
		: Object.fromEntries(result)
}

export const setCache = obj => Object.entries(obj).forEach(
	([key, val]) => val !== undefined && localStorage.setItem(key, val)
)

/**
 * Checks if a user's login period has expired, and redirects them if it has.
 *
 * @param navigate - a navigate hook returned from react-router's useNavigate function
 * @returns true if successful, false otherwise
 */
export const verifyLogin = navigate => {
	const loggedIn = localStorage.getItem('loggedIn')
	const expiration = new Date(30 * 24 * 60 * 60 * 1000).getTime() // 30 days

	if (
		loggedIn
		&& Date.now() - loggedIn < expiration
	) return true

	localStorage.removeItem('loggedIn')
	navigate('/login')

	return false
}
